export default "/images/d25a7b35a9204bd28941f7a68d8eb3dc.avif";